<section class="section-intro">
  <div fxLayout="row" fxLayoutAlign="space-between" class="mb-40">
    <button mat-stroked-button color="primary" (click)="onBackClick()">
      <mat-icon>arrow_back</mat-icon>
      <span>Action summary</span>
    </button>
    <button
      *ngIf="
        (hearingRequest?.userHearingAccess?.canAdjourn ||
          hearingRequest?.userHearingAccess?.canAdjournSineDie) &&
          isCommercialMatter;
        else adjPendingButton
      "
      mat-stroked-button
      color="primary"
      (click)="onAdjournButtonClick()"
    >
      Request Adjournment
    </button>
    <ng-template #adjPendingButton>
      <button
        *ngIf="hearingRequest?.userHearingAccess?.isAdjournmentPending"
        disabled
        mat-stroked-button
        color="primary"
      >
        Pending Adjournment
      </button>
    </ng-template>
    <button
      *ngIf="
        hearingRequest?.userHearingAccess?.canCancelHearingRequest &&
        !isCommercialMatter
      "
      mat-flat-button
      color="warn"
      (click)="onCancelSpecialClick()"
    >
      Cancel civil special
    </button>
  </div>
  <div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
    >
      <div>
        <h2 class="mb-0">
          <div
            *ngIf="
              hearingRequest?.hearingStatusCode ==
                StatusType.AdjournmentSineDiePending ||
                hearingRequest?.hearingStatusCode ==
                  StatusType.AdjouredSineDie ||
                (!hearingRequest?.requestedHearingStartDate &&
                  hearingRequest?.hearingStatusCode ==
                    StatusType.AdjournmentRejected);
              else hearingTime
            "
          >
            Sine Die
          </div>
          <ng-template #hearingTime>
            <div
              *ngIf="
                hearingRequest?.requestedHearingStartDate;
                else noHearingTime
              "
            >
              {{ hearingRequest?.requestedHearingStartDate | date: 'longDate' }}
              ({{ hearingRequest?.justice | incomplete }})
            </div>
          </ng-template>
          <ng-template #noHearingTime>
            <div>Urgent</div>
          </ng-template>
        </h2>
      </div>
      <div>
        <span
          class="status"
          [ngClass]="
            hearingRequest?.hearingStatusCode
              | hearingBadgeStatusColor
                : hearingRequest?.requestedHearingStartDate
          "
          >{{
            hearingRequest?.hearingStatusCode
              | hearingBadgeStatus: hearingRequest?.requestedHearingStartDate
          }}</span
        >
      </div>
    </div>
    <div>{{ hearingRequest?.remedySought | incomplete }}</div>
  </div>
</section>
<ng-container *ngIf="hearingRequest | hearingComments as hearingComments">
  <jsg-section-intro *ngIf="hearingComments?.comment">
    <h3
      *ngIf="
        hearingRequest?.hearingStatusCode == StatusType.Rejected ||
          hearingRequest?.hearingStatusCode == StatusType.AdjournmentRejected;
        else hearingNotesHeader
      "
    >
      Rejection notes
    </h3>
    <ng-template #hearingNotesHeader>
      <h3>Hearing notes</h3>
    </ng-template>
    <jsg-single-row-panel backgroundStyleClass="comment-box">
      <div first>
        <div>
          {{ hearingComments?.commentedBy }}
        </div>
        <div>
          {{ hearingComments?.comment }}
        </div>
      </div>
    </jsg-single-row-panel>
  </jsg-section-intro>
</ng-container>

<ng-container
  *ngIf="hearingRequest?.hearingStatusCode == StatusType.AdjournmentRejected"
>
  <jsg-section-intro *ngIf="hearingRequest?.comments">
    <h3>Reason for adjournment</h3>
    <jsg-single-row-panel backgroundStyleClass="comment-box">
      <div first>
        <div>
          {{ hearingRequest?.requester?.name?.firstLast }}
        </div>
        <div>
          {{ hearingRequest?.comments }}
        </div>
      </div>
    </jsg-single-row-panel>
  </jsg-section-intro>
</ng-container>

<jsg-section-intro>
  <h3>Hearing Requestor</h3>
  <jsg-lawyer-info-view
    [lawFirmName]="hearingRequest?.requester?.organizationName"
    [firstName]="hearingRequest?.requester?.name?.firstName"
    [lastName]="hearingRequest?.requester?.name?.lastName"
    [email]="hearingRequest?.requester?.email"
  >
  </jsg-lawyer-info-view>
</jsg-section-intro>

<section>
  <jsg-section-intro>
    <h3>Hearing Details</h3>
    <jsg-action-hearing-card-details-view
      *ngIf="isCommercialMatter; else jscMatter"
      [hearingRequest]="hearingRequest"
      [calendarRoute]="calendarRoute"
    ></jsg-action-hearing-card-details-view>
    <ng-template #jscMatter>
      <jsg-jsc-action-hearing-card-details-view
        [hearingRequest]="hearingRequest"
        [showCalendarButton]="isCommercialMatter"
        [calendarRoute]="calendarRoute"
      ></jsg-jsc-action-hearing-card-details-view>
      <jsc-hearing-request-documents-view
        [hearingRequestDocuments]="hearingRequestDocuments"
        [displayedColumns]="documentsDisplayedColumns"
        (openFile)="onOpenFile($event)"
      >
      </jsc-hearing-request-documents-view>
    </ng-template>
  </jsg-section-intro>
</section>

<section
  *ngIf="
    hearingRequest?.hearingStatusCode != StatusType.Rejected &&
    hearingRequest?.hearingStatusCode != StatusType.Submitted &&
    hearingRequest?.hearingStatusCode != StatusType.AdjournmentPending &&
    hearingRequest?.hearingStatusCode != StatusType.AdjournmentSineDiePending
  "
>
  <jsg-section-intro>
    <jsg-action-hearing-card-materials-view
      [tableData]="hearingRequest?.associatedHearingMaterials"
      [canAssociateMaterial]="
        hearingRequest?.userHearingAccess?.canAssociateMaterial
      "
      [associateMaterialsSupportText]="associateMaterialsSupportText"
      [associateMaterialsEmptyText]="associateMaterialsEmptyText"
      (associateMaterials)="onAssociateMaterials()"
      (openFile)="onOpenFile($event)"
      (downloadFiles)="onDownloadFiles($event)"
    ></jsg-action-hearing-card-materials-view>
  </jsg-section-intro>
</section>
